module.exports = __webpack_public_path__ + "static/media/candidate.3bd5e46f.svg";